import React from 'react';
import { Wrapper } from './styles.Header';
import { Aside } from './aside/Aside';
import { StaticMedia, MediaType } from '../../custom/staticMedia/StaticMedia';
import { useGlobal } from '../../../logic/main';

interface HeadlineProps {
    img: string;
    video?: string;
    hideAside?: boolean;
    isBig?: boolean;
}

export const Header: React.FC<HeadlineProps> = ({ img, hideAside = false, isBig }) => {
    const [navbarHeight] = useGlobal(state => state.navbarHeight);

    return (
        <Wrapper isBig={isBig} navbarHeight={navbarHeight}>
            <StaticMedia src={img} type={MediaType.IMAGE} />
            {!hideAside ? <Aside darkenAside={true} background={img} /> : null}
        </Wrapper>
    );
};
